<div mat-dialog-title>
  <h2 data-testid="confirm-dialog-title">{{ data.title }}</h2>
</div>
<div mat-dialog-content>
  <p data-testid="confirm-dialog-text" [innerHTML]="data.confirmText"></p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button data-testid="confirm-dialog-cancel" (click)="onCancel()">{{ data.cancelBtn || 'Cancel' }}</button>
  @if (data.confirmBtn) {
    <button mat-flat-button data-testid="confirm-dialog-confirm" [color]="data.color" [mat-dialog-close]="true" cdkFocusInitial>{{ data.confirmBtn }}</button>
  }
</div>
